"use strict";

var _interopRequireWildcard = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _pubilc = require("@/api/system/pubilc");
var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  sysOrgQueryAll: [],
  certificationFlag: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USERINFO: function SET_USERINFO(state, userinfo) {
    state.userinfo = userinfo;
  },
  SET_SYSORGQUERYALL: function SET_SYSORGQUERYALL(state, sysOrgQueryAll) {
    state.sysOrgQueryAll = sysOrgQueryAll;
  },
  SET_CERTIFICATIONFLAG: function SET_CERTIFICATIONFLAG(state, certificationFlag) {
    state.certificationFlag = certificationFlag;
  }
};
var actions = {
  // certificationFlag 行业身份
  setCertificationFlag: function setCertificationFlag(_ref) {
    var commit = _ref.commit;
    var certificationFlag = [{
      name: '医院-宠物',
      id: '1'
    }, {
      name: '医院-人医',
      id: '2'
    }, {
      name: '医院-牙医',
      id: '6'
    }, {
      name: '分销用户',
      id: '8'
    }, {
      name: '流通商',
      id: '3'
    }, {
      name: '制造商',
      id: '4'
    }, {
      name: '四爪星球',
      id: '9'
    },
    // { name: '供应商', id: '5' },
    {
      name: '其它',
      id: '7'
    }];
    commit('SET_CERTIFICATIONFLAG', certificationFlag);
  },
  // orgList
  setSysorgqueryall: function setSysorgqueryall(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      (0, _pubilc.sysOrg_tree)().then(function (response) {
        commit('SET_SYSORGQUERYALL', response.data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user login
  login: function login(_ref3, userInfo) {
    var commit = _ref3.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      (0, _user.login)({
        username: username.trim(),
        password: password
      }).then(function (response) {
        // const { data } = response
        commit('SET_TOKEN', response.token);
        (0, _auth.setToken)(response.token);
        resolve(response.user.userId);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info admin-token
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      // getInfo(state.token).then(response => {
      //   const { data } = response
      //   console.log('--------------1111', response)
      //   console.log('--------------2222', data)
      //   if (!data) {
      //     reject('Verification failed, please Login again.')
      //   }

      //   const { roles } = data

      //   // roles must be a non-empty array
      //   if (!roles || roles.length <= 0) {
      //     reject('getInfo: roles must be a non-null array!')
      //   }

      //   commit('SET_ROLES', roles)
      //   // commit('SET_NAME', name)
      //   // commit('SET_AVATAR', avatar)
      //   // commit('SET_INTRODUCTION', introduction)
      //   resolve(data)w
      // }).catch(error => {
      //   reject(error)
      // })
      // ----------
      var _msg$code$data = {
          'msg': 'success',
          'code': 0,
          'data': {
            'roles': ['admin'],
            'name': 'Super Admin',
            'avatar': 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
            'introduction': 'I am a super administrator'
          }
        },
        data = _msg$code$data.data;
      if (!data) {
        reject('Verification failed, please Login again.');
      }
      var roles = data.roles;

      // roles must be a non-empty array
      if (!roles || roles.length <= 0) {
        reject('getInfo: roles must be a non-null array!');
      }
      commit('SET_ROLES', roles);
      // commit('SET_NAME', name)
      // commit('SET_AVATAR', avatar)
      // commit('SET_INTRODUCTION', introduction)
      resolve(data);
    });
  },
  // user detail msg
  userDetail: function userDetail(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.userDetail)(state.token).then(function (response) {
        sessionStorage.setItem('userDetail', JSON.stringify(response.user));
        commit('SET_NAME', response.user.realName);
        commit('SET_USERINFO', response.user);
        resolve(response.user);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        (0, _auth.removeToken)();
        (0, _router.resetRouter)();

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref8, role) {
    var commit = _ref8.commit,
      dispatch = _ref8.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref9.apply(this, arguments);
      };
    }());
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};